<template lang="pug">
.v-location-picker.location-picker
	v-svg-icon.location-picker__icon(:icon="geolocationData.icon")
	.field-select__btn-text(v-if="geolocationData.plug" ) {{ geolocationData.plug }}
	v-field(v-if="geolocationData && geolocationData.cityId && !geolocationData.plug"
			:field="computedField"
			v-model="this.geolocationData.cityId"
			@update:model-value="setLocation")
</template>
<script>
import controller from '../scripts/controller/controller.js';
export default {
	props: {
		country: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			bxajaxid: null,
			modal: null
		};
	},

	computed: {
		geolocationData() {
			this.modal = this.$store.state.location.modal
			return this.$store.state.location;
		},

		computedField() {
			let field;
			let options = [];
			this.geolocationData.items.forEach(item => {
				options.push({
					value: item.cityId,
					text: item.text
				});
			});
			let currentLocation = this.geolocationData.items.find(item => item.cityId === this.geolocationData.cityId);
			if (options.length > 0) {
				field = {
					type: 'modal-select',
					value: currentLocation,
					title: this.geolocationData.title,
					buttons: this.geolocationData.buttons,
					bxajaxid: this.geolocationData.bxajaxid,
					options
				};
			}
			return field;
		}
	},

	watch: {
		modal() {
			if(this.modal) {
				controller.openModal({
					...this.modal,
				})
			}
		}
	},

	methods: {
		setLocation(cityId) {
			this.$store.dispatch('location/update', {
				cityId: cityId,
				bxajaxid: this.computedField.bxajaxid ? this.computedField.bxajaxid : null,
			});
		}
	}
};
</script>